import React from "react";
import Image from "next/image";

export default function Banner() {
  return (
    <section className="relative w-full h-[360px] sm:h-[460px] lg:h-[560px] overflow-hidden bg-[#3b3a4f]">
      <Image
        src="/images/home/group-3186.webp"
        alt="People's Courage International Data Hub"
        fill
        priority
        placeholder="blur"
        blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QBMRXhpZgAATU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFKADAAQAAAABAAAACgAAAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/8AAEQgACgAUAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/bAEMACQkJCQkJEAkJEBYQEBAWHhYWFhYeJh4eHh4eJi4mJiYmJiYuLi4uLi4uLjc3Nzc3N0BAQEBASEhISEhISEhISP/bAEMBCwwMEhESHxERH0szKjNLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS//dAAQAAv/aAAwDAQACEQMRAD8A8htklMoaOMvg9Mde1dslpMhR4oiY5F6gEEtgEgj26CqMxIiXHYqB7cV2OgTzPqDozsVAXAJOBVcrj7yZmpp3i0Zdr9uMZEKBgrEcqcj2/KrONT/55L/3zXeGOMHhQM8nik2J6D8q5fZQNuaR/9k="
        className="object-cover object-center"
        sizes="(max-width: 1024px) 100vw, 1024px"
      />
      {/* Subtle scrim for text legibility */}
      {/* <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent" /> */}

      <div className="absolute flex flex-col items-start justify-end bg-gradient-to-t from-black/40 via-black/10 to-transparent w-full h-full lg:py-20 md:py-16 py-16 px-4 md:px-12 lg:px-[72px]">
        <h1 className="text-white font-semibold mb-3 lg:mb-[18px]">
          PEOPLE&apos;S COURAGE INTERNATIONAL
        </h1>
        <p className="text-white text-lg sm:text-xl lg:text-[1.3rem] font-medium tracking-wide">
          DATA HUB
        </p>
      </div>
    </section>
  );
}
